import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  getNotifications,
  updateNotifications
} from 'store/notifications-actions';

import Badge from '@mui/material/Badge';
import Menu from '@mui/material/Menu';
import IconButton from '@mui/material/IconButton';
import NotificationsIcon from '@mui/icons-material/Notifications';

import NotificationItem from './NotificationItem/NotificationItem';

import classes from './Notifications.module.css';

let showBag = true;

const Notifications = () => {
  const dispatch = useDispatch();
  const userInfo = useSelector(state => state.userInfo);
  const userNotifications = useSelector(
    state => state.notifications
  );
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  useEffect(() => {
    if (userInfo.data.usuario) {
      dispatch(getNotifications(userInfo.data.usuario));
    }
  }, [userInfo, dispatch]);

  useEffect(() => {
    if (userNotifications.data.stat === 'pending') {
      showBag = false;
    }
  }, [userNotifications, dispatch]);

  const handleClick = event => {
    dispatch(updateNotifications(userInfo.data.usuario));
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        id="notifications-button"
        aria-controls={open ? 'notifications-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <Badge color="secondary" variant="dot" invisible={showBag}>
          <NotificationsIcon className={classes.notificationIcon} />
        </Badge>
      </IconButton>
      <Menu
        className={classes.notificationList}
        id="notifications-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'user-button'
        }}
      >
        {userNotifications.data.notifications &&
          userNotifications.data.notifications.map(notif => (
            <NotificationItem key={notif.created} notif={notif} />
          ))}
      </Menu>
    </>
  );
};

export default Notifications;
